export const isInTwoFactorAuthenticationLoginFlow = (currentUser) => Boolean(currentUser?.hasSetupMfa && !currentUser?.hasCompletedMfa);
